export const validateNxplanForm = (
  form = {},
  { step = 3, baseline = {}, t } = {},
) => {
  const message = (text) => (typeof t === "function" ? t(text) : text);
  const errors = {};

  const nowYear = new Date().getFullYear();
  const baseYearNum = Number(form.baseYear);
  const targetYearNum = Number(form.targetYear);
  const reportingYearNum = Number(form.reportingYear);

  const hasBase = !Number.isNaN(baseYearNum);
  const hasTarget = !Number.isNaN(targetYearNum);
  const hasReporting = !Number.isNaN(reportingYearNum);

  if (step >= 1) {
    if (!form.organizationBoundary) {
      errors.organizationBoundary = message("Select organization boundary.");
    }
    if (!form.baseYear) {
      errors.baseYear = message("Select base year.");
    }
    if (!form.targetYear) {
      errors.targetYear = message("Select target year.");
    }
    if (hasTarget && targetYearNum < nowYear) {
      errors.targetYear = message("Target year should be this year or later.");
    }
    if (hasBase && hasTarget && targetYearNum <= baseYearNum) {
      errors.targetYear = message("Target year should be after base year.");
    }
  }

  if (step >= 2) {
    if (!form.reportingYear) {
      errors.reportingYear = message("Select reporting year.");
    }
    if (hasReporting && reportingYearNum > nowYear) {
      errors.reportingYear = message(
        "Reporting year should not be in the future.",
      );
    }
    if (hasReporting && hasBase && reportingYearNum < baseYearNum) {
      errors.reportingYear = message(
        "Reporting year should be on or after base year.",
      );
    }
    if (hasReporting && hasTarget && reportingYearNum >= targetYearNum) {
      errors.reportingYear = message(
        "Reporting year should be before target year.",
      );
    }
  }

  if (step >= 3) {
    if (!form.isSBTi) {
      errors.isSBTi = message("Select Yes or No.");
    }

    if (form.isSBTi === "yes") {
      if (!form.sbtiTemperature) {
        errors.sbtiTemperature = message("Select SBTi temperature.");
      }
      if (!form.targetType) {
        errors.targetType = message("Select reduction type.");
      }
      if (!form.regressionModel) {
        errors.regressionModel = message("Select model.");
      }
    } else if (form.isSBTi === "no") {
      const tr = Number(form.targetReduction);
      if (form.targetReduction === undefined || form.targetReduction === "") {
        errors.targetReduction = message("Enter target reduction.");
      } else if (Number.isNaN(tr)) {
        errors.targetReduction = message("Enter a numeric percentage.");
      } else if (tr < 0 || tr > 100) {
        errors.targetReduction = message("Enter a value between 0 and 100.");
      }
    }

    ["scope1", "scope2", "scope3"].forEach((key) => {
      const raw = baseline[key];
      if (raw === "" || raw === null || typeof raw === "undefined") return;
      const n = Number(raw);
      if (Number.isNaN(n) || n < 0) {
        errors[`baseline_${key}`] = message("Enter a non-negative number.");
      }
    });
  }

  return errors;
};
